// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EditProductOfferingConfigQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EditProductOfferingConfigQuery = { __typename?: 'Query', productOfferingConfig: { __typename?: 'ProductOfferingConfig', id: string, name: string, isBaseConfig: boolean, salesPriceInCents?: number | null | undefined, publishToUnderwriting: boolean, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> } };

export type AddProductOfferingConfigMetaQueryVariables = Types.Exact<{
  costInput: Types.ComputeProductOfferingCostsAndPricesInput;
  programDataInput: Types.ComputeProgramDataInput;
  productOfferingId: Types.Scalars['ID']['input'];
}>;


export type AddProductOfferingConfigMetaQuery = { __typename?: 'Query', computeProductOfferingCostsAndPrices: { __typename?: 'ComputeProductOfferingCostsAndPricesResponse', totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, order: number, active: boolean, showInCheckout: boolean, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> } }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, required: boolean, isSingleOptionGroup: boolean, isMultiOptionGroup: boolean, order: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string } | null | undefined }, location?: { __typename?: 'Location', id: string, name: string, room?: { __typename?: 'Location', id: string, name: string } | null | undefined } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, name: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, designPackageTagColor?: string | null | undefined } }, type: { __typename?: 'GlobalOptionType', order: number, isSpecLevel: boolean, forDesignInterior: boolean, forDesignExterior: boolean, id: string, name: string } }> }, allOptions: Array<{ __typename?: 'ReadyPlanOptionCostAndPriceDelta', totalCostInCents: number, preCutoffTotalPriceInCents: number, preCutoffDesiredMarginInBasisPoints: number, postCutoffTotalPriceInCents?: number | null | undefined, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents: number, minimumPriceInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } }> }, computeProgramData: { __typename?: 'NewProgramData', sellableSqft?: number | null | undefined }, productOffering: { __typename?: 'ProductOffering', id: string, publishToUnderwriting: boolean, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string } } };

export type AddProductOfferingConfigs_DeltasQueryVariables = Types.Exact<{
  costInput: Types.ComputeProductOfferingCostsAndPricesInput;
  programDataInput: Types.ComputeProgramDataInput;
}>;


export type AddProductOfferingConfigs_DeltasQuery = { __typename?: 'Query', computeProductOfferingCostsAndPrices: { __typename?: 'ComputeProductOfferingCostsAndPricesResponse', totalCostInCents: number, productOffering: { __typename?: 'ProductOffering', id: string }, allOptions: Array<{ __typename?: 'ReadyPlanOptionCostAndPriceDelta', totalCostInCents: number, preCutoffTotalPriceInCents: number, preCutoffDesiredMarginInBasisPoints: number, postCutoffTotalPriceInCents?: number | null | undefined, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents: number, minimumPriceInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } }> }, computeProgramData: { __typename?: 'NewProgramData', sellableSqft?: number | null | undefined } };

export type CreateProjectFromConfigMetaQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
  productOfferingConfigId: Types.Scalars['ID']['input'];
  skipDevelopment: Types.Scalars['Boolean']['input'];
}>;


export type CreateProjectFromConfigMetaQuery = { __typename?: 'Query', cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string }>, project?:
    | { __typename?: 'StandaloneProject', id: string, children: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Region', id: string, children: Array<{ __typename?: 'Market', id: string, name: string }> }
    | { __typename?: 'Market', id: string, children: Array<{ __typename?: 'Community', id: string, name: string }> }
    | { __typename?: 'Community', id: string, children: Array<{ __typename?: 'Subdivision', id: string, name: string }> }
    | { __typename?: 'Subdivision', id: string, children: Array<{ __typename?: 'Lot', id: string, name: string }> }
    | { __typename?: 'Lot', id: string, children: Array<{ __typename?: 'Structure', id: string, name: string }> }
    | { __typename?: 'Structure', id: string, children: Array<{ __typename?: 'Unit', id: string, name: string }> }
    | { __typename?: 'Unit', id: string, children: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
  , productOfferingConfig: { __typename?: 'ProductOfferingConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, productOffering: { __typename?: 'ProductOffering', id: string } }, enumDetails: { __typename?: 'AllEnumDetails', lotType: Array<{ __typename?: 'LotTypeDetail', code: Types.LotType, name: string }> }, projectsPage: { __typename?: 'ProjectsPageResult', entities: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    > } };

export type CreateProjectFromProductOfferingConfigMutationVariables = Types.Exact<{
  input: Types.CreateProjectFromReadyPlanInput;
}>;


export type CreateProjectFromProductOfferingConfigMutation = { __typename?: 'Mutation', createProjectFromReadyPlan: { __typename?: 'SaveProjectResult', project:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
     } };

export type SaveProductOfferingConfigMutationVariables = Types.Exact<{
  input: Types.SaveProductOfferingConfigInput;
}>;


export type SaveProductOfferingConfigMutation = { __typename?: 'Mutation', saveProductOfferingConfig: { __typename?: 'SaveProductOfferingConfigResult', productOfferingConfig: { __typename?: 'ProductOfferingConfig', id: string, name: string, isBaseConfig: boolean, salesPriceInCents?: number | null | undefined, publishToUnderwriting: boolean, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> } } };

export type EditProductOfferingConfig_ProductOfferingConfigFragment = { __typename?: 'ProductOfferingConfig', id: string, name: string, isBaseConfig: boolean, salesPriceInCents?: number | null | undefined, publishToUnderwriting: boolean, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> };

export type RpoDeltaFragment = { __typename?: 'ReadyPlanOptionCostAndPriceDelta', totalCostInCents: number, preCutoffTotalPriceInCents: number, preCutoffDesiredMarginInBasisPoints: number, postCutoffTotalPriceInCents?: number | null | undefined, postCutoffDesiredMarginInBasisPoints?: number | null | undefined, selectionFeeInCents: number, minimumPriceInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string } };

export type AddProductOfferingConfig_ReadyPlanOptionsFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, order: number, active: boolean, showInCheckout: boolean, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> } }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, required: boolean, isSingleOptionGroup: boolean, isMultiOptionGroup: boolean, order: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string } | null | undefined }, location?: { __typename?: 'Location', id: string, name: string, room?: { __typename?: 'Location', id: string, name: string } | null | undefined } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, name: string, asset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, designPackageTagColor?: string | null | undefined } }, type: { __typename?: 'GlobalOptionType', order: number, isSpecLevel: boolean, forDesignInterior: boolean, forDesignExterior: boolean, id: string, name: string } };

export const EditProductOfferingConfig_ProductOfferingConfigFragmentDoc = gql`
    fragment EditProductOfferingConfig_ProductOfferingConfig on ProductOfferingConfig {
  id
  name
  isBaseConfig
  salesPriceInCents
  readyPlanOptions {
    id
    active
  }
  publishToUnderwriting
}
    `;
export const RpoDeltaFragmentDoc = gql`
    fragment RpoDelta on ReadyPlanOptionCostAndPriceDelta {
  readyPlanOption {
    id
  }
  totalCostInCents
  preCutoffTotalPriceInCents
  preCutoffDesiredMarginInBasisPoints
  postCutoffTotalPriceInCents
  postCutoffDesiredMarginInBasisPoints
  selectionFeeInCents
  minimumPriceInCents
}
    `;
export const AddProductOfferingConfig_ReadyPlanOptionsFragmentDoc = gql`
    fragment AddProductOfferingConfig_ReadyPlanOptions on ReadyPlanOption {
  id
  name
  order
  active
  showInCheckout
  optionConflicts {
    id
    displayName
  }
  optionConflictChildren {
    id
    displayName
  }
  optionPrerequisites {
    id
    displayName
    optionGroup {
      id
      options {
        id
      }
    }
  }
  optionPrereqChildren {
    id
    displayName
  }
  optionGroup {
    id
    name
    required
    isSingleOptionGroup
    isMultiOptionGroup
    order
    options {
      id
      displayName
    }
    personalizationType {
      code
      name
    }
  }
  location {
    id
    room {
      id
      name
    }
  }
  globalOption {
    id
    name
    asset {
      id
      previewUrl(resizing: {width: 250, region: FULL})
    }
    group {
      id
      designPackageTagColor
    }
  }
  type {
    ...Named
    order
    isSpecLevel
    forDesignInterior
    forDesignExterior
  }
  location {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const EditProductOfferingConfigDocument = gql`
    query EditProductOfferingConfig($id: ID!) {
  productOfferingConfig(id: $id) {
    ...EditProductOfferingConfig_ProductOfferingConfig
  }
}
    ${EditProductOfferingConfig_ProductOfferingConfigFragmentDoc}`;

/**
 * __useEditProductOfferingConfigQuery__
 *
 * To run a query within a React component, call `useEditProductOfferingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProductOfferingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProductOfferingConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditProductOfferingConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables> & ({ variables: EditProductOfferingConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>(EditProductOfferingConfigDocument, options);
      }
export function useEditProductOfferingConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>(EditProductOfferingConfigDocument, options);
        }
// @ts-ignore
export function useEditProductOfferingConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>;
export function useEditProductOfferingConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditProductOfferingConfigQuery | undefined, EditProductOfferingConfigQueryVariables>;
export function useEditProductOfferingConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>(EditProductOfferingConfigDocument, options);
        }
export type EditProductOfferingConfigQueryHookResult = ReturnType<typeof useEditProductOfferingConfigQuery>;
export type EditProductOfferingConfigLazyQueryHookResult = ReturnType<typeof useEditProductOfferingConfigLazyQuery>;
export type EditProductOfferingConfigSuspenseQueryHookResult = ReturnType<typeof useEditProductOfferingConfigSuspenseQuery>;
export type EditProductOfferingConfigQueryResult = Apollo.QueryResult<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>;
export const AddProductOfferingConfigMetaDocument = gql`
    query AddProductOfferingConfigMeta($costInput: ComputeProductOfferingCostsAndPricesInput!, $programDataInput: ComputeProgramDataInput!, $productOfferingId: ID!) {
  computeProductOfferingCostsAndPrices(input: $costInput) {
    productOffering {
      ...Named
      options {
        ...AddProductOfferingConfig_ReadyPlanOptions
      }
    }
    totalCostInCents
    allOptions {
      ...RpoDelta
    }
  }
  computeProgramData(input: $programDataInput) {
    sellableSqft
  }
  productOffering(id: $productOfferingId) {
    id
    publishToUnderwriting
    ...Named
    version {
      id
    }
    status {
      code
      name
    }
  }
}
    ${NamedFragmentDoc}
${AddProductOfferingConfig_ReadyPlanOptionsFragmentDoc}
${RpoDeltaFragmentDoc}`;

/**
 * __useAddProductOfferingConfigMetaQuery__
 *
 * To run a query within a React component, call `useAddProductOfferingConfigMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProductOfferingConfigMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProductOfferingConfigMetaQuery({
 *   variables: {
 *      costInput: // value for 'costInput'
 *      programDataInput: // value for 'programDataInput'
 *      productOfferingId: // value for 'productOfferingId'
 *   },
 * });
 */
export function useAddProductOfferingConfigMetaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables> & ({ variables: AddProductOfferingConfigMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>(AddProductOfferingConfigMetaDocument, options);
      }
export function useAddProductOfferingConfigMetaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>(AddProductOfferingConfigMetaDocument, options);
        }
// @ts-ignore
export function useAddProductOfferingConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>;
export function useAddProductOfferingConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductOfferingConfigMetaQuery | undefined, AddProductOfferingConfigMetaQueryVariables>;
export function useAddProductOfferingConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>(AddProductOfferingConfigMetaDocument, options);
        }
export type AddProductOfferingConfigMetaQueryHookResult = ReturnType<typeof useAddProductOfferingConfigMetaQuery>;
export type AddProductOfferingConfigMetaLazyQueryHookResult = ReturnType<typeof useAddProductOfferingConfigMetaLazyQuery>;
export type AddProductOfferingConfigMetaSuspenseQueryHookResult = ReturnType<typeof useAddProductOfferingConfigMetaSuspenseQuery>;
export type AddProductOfferingConfigMetaQueryResult = Apollo.QueryResult<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>;
export const AddProductOfferingConfigs_DeltasDocument = gql`
    query AddProductOfferingConfigs_Deltas($costInput: ComputeProductOfferingCostsAndPricesInput!, $programDataInput: ComputeProgramDataInput!) {
  computeProductOfferingCostsAndPrices(input: $costInput) {
    productOffering {
      id
    }
    totalCostInCents
    allOptions {
      ...RpoDelta
    }
  }
  computeProgramData(input: $programDataInput) {
    sellableSqft
  }
}
    ${RpoDeltaFragmentDoc}`;

/**
 * __useAddProductOfferingConfigs_DeltasQuery__
 *
 * To run a query within a React component, call `useAddProductOfferingConfigs_DeltasQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProductOfferingConfigs_DeltasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProductOfferingConfigs_DeltasQuery({
 *   variables: {
 *      costInput: // value for 'costInput'
 *      programDataInput: // value for 'programDataInput'
 *   },
 * });
 */
export function useAddProductOfferingConfigs_DeltasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddProductOfferingConfigs_DeltasQuery, AddProductOfferingConfigs_DeltasQueryVariables> & ({ variables: AddProductOfferingConfigs_DeltasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddProductOfferingConfigs_DeltasQuery, AddProductOfferingConfigs_DeltasQueryVariables>(AddProductOfferingConfigs_DeltasDocument, options);
      }
export function useAddProductOfferingConfigs_DeltasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddProductOfferingConfigs_DeltasQuery, AddProductOfferingConfigs_DeltasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddProductOfferingConfigs_DeltasQuery, AddProductOfferingConfigs_DeltasQueryVariables>(AddProductOfferingConfigs_DeltasDocument, options);
        }
// @ts-ignore
export function useAddProductOfferingConfigs_DeltasSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfigs_DeltasQuery, AddProductOfferingConfigs_DeltasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductOfferingConfigs_DeltasQuery, AddProductOfferingConfigs_DeltasQueryVariables>;
export function useAddProductOfferingConfigs_DeltasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfigs_DeltasQuery, AddProductOfferingConfigs_DeltasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductOfferingConfigs_DeltasQuery | undefined, AddProductOfferingConfigs_DeltasQueryVariables>;
export function useAddProductOfferingConfigs_DeltasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfigs_DeltasQuery, AddProductOfferingConfigs_DeltasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddProductOfferingConfigs_DeltasQuery, AddProductOfferingConfigs_DeltasQueryVariables>(AddProductOfferingConfigs_DeltasDocument, options);
        }
export type AddProductOfferingConfigs_DeltasQueryHookResult = ReturnType<typeof useAddProductOfferingConfigs_DeltasQuery>;
export type AddProductOfferingConfigs_DeltasLazyQueryHookResult = ReturnType<typeof useAddProductOfferingConfigs_DeltasLazyQuery>;
export type AddProductOfferingConfigs_DeltasSuspenseQueryHookResult = ReturnType<typeof useAddProductOfferingConfigs_DeltasSuspenseQuery>;
export type AddProductOfferingConfigs_DeltasQueryResult = Apollo.QueryResult<AddProductOfferingConfigs_DeltasQuery, AddProductOfferingConfigs_DeltasQueryVariables>;
export const CreateProjectFromConfigMetaDocument = gql`
    query CreateProjectFromConfigMeta($developmentId: ID!, $projectId: ID!, $productOfferingConfigId: ID!, $skipDevelopment: Boolean!) {
  cohorts(filter: {development: [$developmentId]}) @skip(if: $skipDevelopment) {
    id
    name
  }
  project(id: $projectId) @include(if: $skipDevelopment) {
    id
    children {
      id
      name
    }
  }
  productOfferingConfig(id: $productOfferingConfigId) {
    id
    readyPlanOptions {
      id
    }
    productOffering {
      id
    }
  }
  enumDetails {
    lotType {
      code
      name
    }
  }
  projectsPage(
    filter: {type: [StandaloneProject], isTest: false, status: [ACTIVE]}
  ) {
    entities {
      id
      name
    }
  }
}
    `;

/**
 * __useCreateProjectFromConfigMetaQuery__
 *
 * To run a query within a React component, call `useCreateProjectFromConfigMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFromConfigMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateProjectFromConfigMetaQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *      projectId: // value for 'projectId'
 *      productOfferingConfigId: // value for 'productOfferingConfigId'
 *      skipDevelopment: // value for 'skipDevelopment'
 *   },
 * });
 */
export function useCreateProjectFromConfigMetaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables> & ({ variables: CreateProjectFromConfigMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>(CreateProjectFromConfigMetaDocument, options);
      }
export function useCreateProjectFromConfigMetaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>(CreateProjectFromConfigMetaDocument, options);
        }
// @ts-ignore
export function useCreateProjectFromConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>;
export function useCreateProjectFromConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateProjectFromConfigMetaQuery | undefined, CreateProjectFromConfigMetaQueryVariables>;
export function useCreateProjectFromConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>(CreateProjectFromConfigMetaDocument, options);
        }
export type CreateProjectFromConfigMetaQueryHookResult = ReturnType<typeof useCreateProjectFromConfigMetaQuery>;
export type CreateProjectFromConfigMetaLazyQueryHookResult = ReturnType<typeof useCreateProjectFromConfigMetaLazyQuery>;
export type CreateProjectFromConfigMetaSuspenseQueryHookResult = ReturnType<typeof useCreateProjectFromConfigMetaSuspenseQuery>;
export type CreateProjectFromConfigMetaQueryResult = Apollo.QueryResult<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>;
export const CreateProjectFromProductOfferingConfigDocument = gql`
    mutation CreateProjectFromProductOfferingConfig($input: CreateProjectFromReadyPlanInput!) {
  createProjectFromReadyPlan(input: $input) {
    project {
      id
      name
    }
  }
}
    `;
export type CreateProjectFromProductOfferingConfigMutationFn = Apollo.MutationFunction<CreateProjectFromProductOfferingConfigMutation, CreateProjectFromProductOfferingConfigMutationVariables>;

/**
 * __useCreateProjectFromProductOfferingConfigMutation__
 *
 * To run a mutation, you first call `useCreateProjectFromProductOfferingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFromProductOfferingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFromProductOfferingConfigMutation, { data, loading, error }] = useCreateProjectFromProductOfferingConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectFromProductOfferingConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectFromProductOfferingConfigMutation, CreateProjectFromProductOfferingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectFromProductOfferingConfigMutation, CreateProjectFromProductOfferingConfigMutationVariables>(CreateProjectFromProductOfferingConfigDocument, options);
      }
export type CreateProjectFromProductOfferingConfigMutationHookResult = ReturnType<typeof useCreateProjectFromProductOfferingConfigMutation>;
export type CreateProjectFromProductOfferingConfigMutationResult = Apollo.MutationResult<CreateProjectFromProductOfferingConfigMutation>;
export type CreateProjectFromProductOfferingConfigMutationOptions = Apollo.BaseMutationOptions<CreateProjectFromProductOfferingConfigMutation, CreateProjectFromProductOfferingConfigMutationVariables>;
export const SaveProductOfferingConfigDocument = gql`
    mutation SaveProductOfferingConfig($input: SaveProductOfferingConfigInput!) {
  saveProductOfferingConfig(input: $input) {
    productOfferingConfig {
      ...EditProductOfferingConfig_ProductOfferingConfig
    }
  }
}
    ${EditProductOfferingConfig_ProductOfferingConfigFragmentDoc}`;
export type SaveProductOfferingConfigMutationFn = Apollo.MutationFunction<SaveProductOfferingConfigMutation, SaveProductOfferingConfigMutationVariables>;

/**
 * __useSaveProductOfferingConfigMutation__
 *
 * To run a mutation, you first call `useSaveProductOfferingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProductOfferingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProductOfferingConfigMutation, { data, loading, error }] = useSaveProductOfferingConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProductOfferingConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProductOfferingConfigMutation, SaveProductOfferingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProductOfferingConfigMutation, SaveProductOfferingConfigMutationVariables>(SaveProductOfferingConfigDocument, options);
      }
export type SaveProductOfferingConfigMutationHookResult = ReturnType<typeof useSaveProductOfferingConfigMutation>;
export type SaveProductOfferingConfigMutationResult = Apollo.MutationResult<SaveProductOfferingConfigMutation>;
export type SaveProductOfferingConfigMutationOptions = Apollo.BaseMutationOptions<SaveProductOfferingConfigMutation, SaveProductOfferingConfigMutationVariables>;